import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, RefreshCw, Users } from "lucide-react";
import { admin } from "@/lib/api";
import { TabHeader, fmtDate } from "@/admin/ui";

export default function SubscribersTab() {
  const [items, setItems] = useState(null);

  const load = () => admin.subscribers().then(setItems).catch(() => toast.error("Could not load subscribers"));
  useEffect(() => { load(); }, []);

  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.email}?`)) return;
    await admin.removeSubscriber(s.id);
    toast.success("Subscriber removed");
    load();
  };

  return (
    <div data-testid="admin-subscribers-tab">
      <div className="flex items-start justify-between gap-4">
        <TabHeader title="Newsletter Subscribers" description="Everyone who subscribed through the footer signup." />
        <button onClick={load} data-testid="admin-subscribers-refresh" className="btn-secondary !px-4 !py-2 !text-xs">
          <RefreshCw className="h-3.5 w-3.5" /> Refresh
        </button>
      </div>
      {items && (
        <p className="mt-6 flex items-center gap-2 text-sm text-muted-foreground" data-testid="admin-subscriber-count">
          <Users className="h-4 w-4" /> {items.length} {items.length === 1 ? "subscriber" : "subscribers"}
        </p>
      )}
      <div className="mt-4 space-y-2">
        {(items || []).map((s) => (
          <div key={s.id} data-testid={`admin-subscriber-${s.id}`} className="flex items-center gap-3 rounded-2xl border border-border bg-card px-5 py-3.5 shadow-soft">
            <p className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">{s.email}</p>
            <span className="text-xs text-muted-foreground">{fmtDate(s.created_at)}</span>
            <button onClick={() => remove(s)} data-testid={`admin-subscriber-delete-${s.id}`} aria-label={`Remove ${s.email}`} className="rounded-full border border-border p-2 text-muted-foreground transition-colors duration-300 hover:border-destructive hover:text-destructive">
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
        {items && items.length === 0 && (
          <p className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">No subscribers yet.</p>
        )}
      </div>
    </div>
  );
}
